import { UserActionCode } from '../api';
import { UserActionRoutePayload } from './types';

type UserActionRouteResolver = (payload: UserActionRoutePayload) => string | null;

const getShipmentId = (payload: UserActionRoutePayload): string | undefined => {
  const {
    action,
    context
  } = payload;

  if (context?.shipmentId) return context.shipmentId;
  if (action.subject.type === 'SHIPMENT') return action.subject.id;
  if (action.details && 'shipment_id' in action.details && typeof action.details.shipment_id === 'string') {
    return action.details.shipment_id;
  }

  return undefined;
};

const userActionRouteByCode: Record<UserActionCode, UserActionRouteResolver> = {
  ADD_MCHD: () => '/profile',
  CONFIRM_RECEPTION_DECISION: (payload) => {
    const shipmentId = getShipmentId(payload);

    return shipmentId ? `/shipments/${encodeURIComponent(shipmentId)}/reception` : null;
  },
  CONFIRM_SHIPMENT_DETAILS: (payload) => {
    const shipmentId = getShipmentId(payload);

    return shipmentId ? `/shipments/${encodeURIComponent(shipmentId)}/shipment-details?mode=edit` : null;
  },
  CONFIRM_SUPPLIER_DATA: (payload) => {
    const shipmentId = getShipmentId(payload);

    return shipmentId
      ? `/shipments/${encodeURIComponent(shipmentId)}/supplier-data?mode=edit&source=confirm-supplier-data`
      : null;
  },
  DECIDE_UNRELEASED_ITEM: (payload) => {
    const shipmentId = getShipmentId(payload);

    if (!shipmentId) return null;

    if (payload.context?.source === 'main') {
      return `/shipments/${encodeURIComponent(shipmentId)}`;
    }

    return `/shipments/${encodeURIComponent(shipmentId)}/customs-clearance`;
  },
  PAY_ADVANCE: () => '/finance',
  PAY_CUSTOMS_SURCHARGE: () => '/finance',
  PAY_SCHEDULED: () => '/finance',
  PAY_SETTLEMENT: () => '/finance',
  SEND_QR_TO_SUPPLIER: () => null,
  SET_ARRIVAL_DATE_AND_DROP_OFF_POINT: () => null,
  UPDATE_MCHD: () => '/profile',
  VIEW_RECEPTION_RESULTS: (payload) => {
    const shipmentId = getShipmentId(payload);

    return shipmentId ? `/shipments/${encodeURIComponent(shipmentId)}/reception` : null;
  }
};

export const getUserActionRoute = (payload: UserActionRoutePayload): string | null => {
  return userActionRouteByCode[payload.action.code](payload);
};